import React from 'react';
import { createRoot } from 'react-dom/client';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import store from './store/store';
import routes from './routes';
import '../css/main.css';

createRoot(document.getElementById("app")).render(
  <DndProvider backend={HTML5Backend}>
    {routes(store)}
  </DndProvider>
);
